import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  ElementRef,
  Input,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DisplayError, ErrorService } from '../../../../services/error.service';
import { WindowRef } from '../../../../services/windowRef';
import { AnalyticsService } from '../../../../services/analytics.service';
import { GTMTracking } from '../../../../enums/google-analytics-tracking';

@Component({
  selector: 'input-code-form',
  templateUrl: './input-code-form.component.html',
})
export class InputCodeFormComponent implements OnInit {
  inputCodeForm: FormGroup;
  inputCode: FormControl;
  formDirty: boolean;
  showBackButton = false;
  @Input() title: string;
  @Input() tooltip: string;
  @Input() hyperlinkText: string;
  @Input() requiredErrorMessage: string;
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() textVisible = true;
  @Input() hyperlinkRightAligned = true;
  @Input() formName: string;
  @Output() onValid = new EventEmitter();
  @Output() onBack = new EventEmitter();
  @Output() onHyperlink = new EventEmitter();

  constructor(
    private elementRef: ElementRef,
    private windowRef: WindowRef,
    private errorService: ErrorService,
    private analyticsService: AnalyticsService
  ) {
    this.errorService.clear();
  }

  get errors(): Array<DisplayError> {
    return this.errorService.errors;
  }

  ngOnInit(): void {
    this.showBackButton = this.onBack.observers.length > 0;
    this.createForm();
  }

  onSubmit() {
    this.formDirty = true;
    this.errorService.clear();
    if (this.inputCodeForm.valid) {
      this.onValid.emit(this.inputCode.value);
    } else {
      this.windowRef.scrollToTop(this.elementRef);
    }
  }

  onBackButtonClick() {
    this.onBack.emit();
  }

  onHyperlinkClick(e: Event) {
    e.preventDefault();
    this.onHyperlink.emit();
  }

  onTooltipClick(e: Event) {
    e.preventDefault();
    if (this.formName === 'register') {
      this.analyticsService.trackCtaActions(GTMTracking.OrnTooltip);
    }
  }

  private createForm() {
    const validators = [Validators.required];

    if (this.maxLength) {
      validators.push(Validators.maxLength(this.maxLength));
    }

    if (this.minLength) {
      validators.push(Validators.minLength(this.minLength));
    }

    this.inputCode = new FormControl('', {
      validators: validators,
      updateOn: 'submit',
    });
    this.inputCodeForm = new FormGroup({
      inputCode: this.inputCode,
    });
  }
}
